@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object RateRideAdminEndpoint : EndPoint<RateRideAdminEndpoint.Request, RateRideAdminEndpoint.Response>() {
    class Request(
        val rideId: KmmLong,
        val rating: Double,
        val review: String,
    )

    class Response()
}